// extracted by mini-css-extract-plugin
export default {"skillsSection":"Skills_skillsSection__RFhQu","show":"Skills_show__nd4Eu","title":"Skills_title__nrz14","card":"Skills_card__ujZTR","skillsList":"Skills_skillsList__ydseq"};